export const communityPosts = [
  {
    id: '1',
    author: '小明（北京）',
    avatar: 'https://public.readdy.ai/ai/img_res/27f591579502bbe22b832fc8a4d0c67f.jpg',
    role: 'student',
    grade: '高三',
    region: '城市',
    content: '我是北京的高三学生，最近在备考高考数学，有没有同学一起刷题？可以互相分享错题本！',
    likes: 234,
    comments: 45,
    time: '2小时前',
    tags: ['高考', '数学', '刷题'],
    emotion: '💪',
  },
  {
    id: '2',
    author: '小花（湖南农村）',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20girl%20student%20smiling%20portrait%2C%20simple%20background%2C%20friendly%20and%20studious%20look&width=80&height=80&seq=a002&orientation=squarish',
    role: 'student',
    grade: '高二',
    region: '农村',
    content: '我来自湖南农村，英语基础比较薄弱，希望能找到城市的同学帮我提高英语口语，我可以教你们方言和农村生活知识！',
    likes: 567,
    comments: 89,
    time: '4小时前',
    tags: ['英语', '互助', '交友'],
    emotion: '🙏',
  },
  {
    id: '3',
    author: '王老师',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20middle-aged%20male%20teacher%20portrait%2C%20professional%20look%2C%20glasses%2C%20warm%20smile%2C%20clean%20background&width=80&height=80&seq=a003&orientation=squarish',
    role: 'teacher',
    grade: '高中数学',
    region: '上海',
    content: '今晚8点我会在平台上直播讲解高考数学最后冲刺的重点题型，欢迎所有高三同学参加，免费！',
    likes: 1203,
    comments: 234,
    time: '6小时前',
    tags: ['高考', '数学', '直播', '免费'],
    emotion: '🎓',
  },
  {
    id: '4',
    author: '李妈妈',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20mother%20portrait%2C%20warm%20smile%2C%20caring%20expression%2C%20clean%20background&width=80&height=80&seq=a004&orientation=squarish',
    role: 'parent',
    grade: '小学四年级',
    region: '广州',
    content: '我女儿在广州读小学四年级，性格开朗，学习认真，希望能找到同年级的小朋友一起学习交流，最好是喜欢数学和画画的！',
    likes: 89,
    comments: 23,
    time: '1天前',
    tags: ['小学', '交友', '数学', '画画'],
    emotion: '😊',
  },
  {
    id: '5',
    author: '阿强（云南）',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20rural%20boy%20student%20portrait%2C%20simple%20clothes%2C%20hopeful%20expression%2C%20clean%20background&width=80&height=80&seq=a005&orientation=squarish',
    role: 'student',
    grade: '高三',
    region: '农村',
    content: '今天模拟考数学只考了89分，有点沮丧😔 但我不会放弃！有没有大神愿意免费帮我讲讲函数这块？我真的很努力，只是缺少好的资源。',
    likes: 892,
    comments: 156,
    time: '3小时前',
    tags: ['求助', '数学', '高考', '免费辅导'],
    emotion: '😔',
    isHelpRequest: true,
  },
  {
    id: '6',
    author: '陈大学姐（清华）',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20female%20university%20student%20portrait%2C%20confident%20smile%2C%20clean%20background%2C%20academic%20look&width=80&height=80&seq=a006&orientation=squarish',
    role: 'student',
    grade: '大学',
    region: '北京',
    content: '我是清华大学大三学生，愿意免费帮助农村的高三同学辅导数学和物理！每周可以抽出3小时，一起加油！有需要的同学请留言。',
    likes: 2341,
    comments: 389,
    time: '5小时前',
    tags: ['免费辅导', '数学', '物理', '公益'],
    emotion: '❤️',
    isHelper: true,
  },
  {
    id: '7',
    author: '张英语老师',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20English%20teacher%20portrait%2C%20professional%20smile%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=a007&orientation=squarish',
    role: 'teacher',
    grade: '英语',
    region: '深圳',
    content: '感受到了很多农村孩子对学习的渴望，决定每周六下午2点免费直播英语课，专门针对基础薄弱的同学。知识改变命运，我们一起！',
    likes: 3456,
    comments: 567,
    time: '8小时前',
    tags: ['免费', '英语', '公益', '直播'],
    emotion: '🌟',
    isHelper: true,
  },
  {
    id: '8',
    author: '小雨（贵州）',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20girl%20student%20portrait%2C%20rural%20background%2C%20hopeful%20eyes%2C%20simple%20clothes&width=80&height=80&seq=a008&orientation=squarish',
    role: 'student',
    grade: '初三',
    region: '农村',
    content: '今天收到了平台寄来的文具礼包，里面有钢笔、笔记本和彩色铅笔！感谢所有捐款的叔叔阿姨，我一定好好学习，将来也要帮助更多人！',
    likes: 1567,
    comments: 234,
    time: '1天前',
    tags: ['感恩', '礼物', '公益', '感动'],
    emotion: '😭',
    isVillageShare: true,
  },
  {
    id: '9',
    author: '大山里的阿牛',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20rural%20boy%20student%20portrait%2C%20mountain%20village%20background%2C%20genuine%20smile%2C%20simple%20clothes&width=80&height=80&seq=a009&orientation=squarish',
    role: 'student',
    grade: '初二',
    region: '农村',
    content: '今天带大家看看我们村子的早晨🌄 每天5点起床，走40分钟山路去上学。虽然辛苦，但看到山顶的日出，感觉一切都值得。城市的同学们，你们也要珍惜每天上学的机会哦！',
    likes: 4521,
    comments: 678,
    time: '2天前',
    tags: ['农村生活', '励志', '分享', '感恩'],
    emotion: '🌄',
    isVillageShare: true,
    hasImage: true,
  },
  {
    id: '10',
    author: '苗家小妹（贵州）',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20Miao%20ethnic%20girl%20student%20portrait%2C%20traditional%20elements%2C%20warm%20smile%2C%20clean%20background&width=80&height=80&seq=a010&orientation=squarish',
    role: 'student',
    grade: '高一',
    region: '农村',
    content: '我把城市同学送来的新书包分享给了班里最需要的同学小芳，她家里很困难，看到她开心的样子我也好幸福。爱心是可以传递的！',
    likes: 2890,
    comments: 345,
    time: '3天前',
    tags: ['爱心传递', '分享', '感恩', '农村'],
    emotion: '❤️',
    isVillageShare: true,
  },
];

export const studyGroups = [
  { id: '1', name: '高考数学冲刺群', members: 2340, category: '高考', icon: 'ri-calculator-line' },
  { id: '2', name: '考研英语备考群', members: 1890, category: '考研', icon: 'ri-global-line' },
  { id: '3', name: '托福雅思交流群', members: 1230, category: '英语考试', icon: 'ri-translate-2' },
  { id: '4', name: '会计从业资格群', members: 980, category: '职业考试', icon: 'ri-money-cny-circle-line' },
  { id: '5', name: '小学奥数兴趣群', members: 3450, category: '小学', icon: 'ri-star-line' },
  { id: '6', name: '初中物理化学群', members: 2100, category: '初中', icon: 'ri-flask-line' },
];

export const helpProviders = [
  {
    id: 'h1',
    name: '陈大学姐',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20female%20university%20student%20portrait%2C%20confident%20smile%2C%20clean%20background%2C%20academic%20look&width=80&height=80&seq=h001&orientation=squarish',
    school: '清华大学 大三',
    subjects: ['数学', '物理', '化学'],
    rating: 4.9,
    helped: 234,
    badge: '优秀志愿者',
    badgeColor: 'bg-amber-100 text-amber-700',
    free: true,
  },
  {
    id: 'h2',
    name: '王老师',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20middle-aged%20male%20teacher%20portrait%2C%20professional%20look%2C%20glasses%2C%20warm%20smile%2C%20clean%20background&width=80&height=80&seq=h002&orientation=squarish',
    school: '高中数学教师 · 15年经验',
    subjects: ['数学', '高考冲刺'],
    rating: 5.0,
    helped: 1203,
    badge: '认证教师',
    badgeColor: 'bg-green-100 text-green-700',
    free: true,
  },
  {
    id: 'h3',
    name: '张英语老师',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20English%20teacher%20portrait%2C%20professional%20smile%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=h003&orientation=squarish',
    school: '英语专业教师 · 10年经验',
    subjects: ['英语', '托福', '雅思'],
    rating: 4.8,
    helped: 876,
    badge: '认证教师',
    badgeColor: 'bg-green-100 text-green-700',
    free: true,
  },
  {
    id: 'h4',
    name: '李学长',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20male%20university%20student%20portrait%2C%20friendly%20smile%2C%20clean%20background%2C%20casual%20look&width=80&height=80&seq=h004&orientation=squarish',
    school: '北京大学 研究生',
    subjects: ['考研数学', '考研英语', '政治'],
    rating: 4.7,
    helped: 456,
    badge: '考研达人',
    badgeColor: 'bg-red-100 text-red-700',
    free: true,
  },
];

export const emotionOptions = [
  { emoji: '😊', label: '开心' },
  { emoji: '💪', label: '加油' },
  { emoji: '😔', label: '沮丧' },
  { emoji: '🙏', label: '求助' },
  { emoji: '❤️', label: '感恩' },
  { emoji: '🌟', label: '分享' },
  { emoji: '😭', label: '感动' },
  { emoji: '🎓', label: '学习' },
];

export const donationStats = {
  totalDonors: 12847,
  totalAmount: 2340000,
  infantsHelped: 8923,
  countries: 23,
};

export const donationRecords = [
  {
    id: 'd1',
    donor: '爱心家长·张先生',
    donorCity: '北京',
    amount: 500,
    date: '2026-04-10',
    gifts: ['钢笔套装×3', '笔记本×5', '彩色铅笔×2'],
    recipient: '云南昭通·苗翠花',
    recipientGrade: '高中二年级',
    recipientRegion: '云南省昭通市彝良县',
    status: '已送达',
    recipientAvatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20girl%20student%20Yunnan%20rural%20area%20warm%20smile%20school%20uniform%20clean%20background%20portrait&width=60&height=60&seq=dr001&orientation=squarish',
    donorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20professional%20man%20portrait%2C%20kind%20smile%2C%20clean%20background%2C%20middle%20aged&width=60&height=60&seq=dd001&orientation=squarish',
    thankNote: '谢谢叔叔的礼物！我会好好用这些文具，认真学习，将来考上好大学！',
  },
  {
    id: 'd2',
    donor: '爱心妈妈·李女士',
    donorCity: '上海',
    amount: 300,
    date: '2026-04-09',
    gifts: ['校服套装×1', '书包×1'],
    recipient: '贵州黔东南·吴小梅',
    recipientGrade: '初中三年级',
    recipientRegion: '贵州省黔东南苗族侗族自治州',
    status: '已送达',
    recipientAvatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20girl%20student%20Guizhou%20rural%20area%20happy%20expression%20school%20uniform%20clean%20background%20portrait&width=60&height=60&seq=dr002&orientation=squarish',
    donorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20professional%20woman%20portrait%2C%20warm%20smile%2C%20clean%20background%2C%20middle%20aged&width=60&height=60&seq=dd002&orientation=squarish',
    thankNote: '新书包太漂亮了！我每天背着它去上学，同学们都说好看，我好开心！',
  },
  {
    id: 'd3',
    donor: '爱心企业·科技公司',
    donorCity: '深圳',
    amount: 2000,
    date: '2026-04-08',
    gifts: ['文具套装×20', '课外书×30', '冬季棉服×10'],
    recipient: '甘肃定西·多名学生',
    recipientGrade: '小学至初中',
    recipientRegion: '甘肃省定西市通渭县',
    status: '已送达',
    recipientAvatar: 'https://readdy.ai/api/search-image?query=group%20of%20young%20Chinese%20rural%20students%20smiling%20together%2C%20simple%20clothes%2C%20clean%20background&width=60&height=60&seq=dr003&orientation=squarish',
    donorAvatar: 'https://readdy.ai/api/search-image?query=modern%20tech%20company%20logo%20style%2C%20clean%20professional%20background&width=60&height=60&seq=dd003&orientation=squarish',
    thankNote: '我们全班同学都收到了礼物，老师说这是城市里的好心人送来的，我们一定要好好学习！',
  },
  {
    id: 'd4',
    donor: '爱心学生·王同学',
    donorCity: '广州',
    amount: 150,
    date: '2026-04-07',
    gifts: ['英语词典×2', '练习本×10'],
    recipient: '四川凉山·阿依',
    recipientGrade: '高中一年级',
    recipientRegion: '四川省凉山彝族自治州',
    status: '已送达',
    recipientAvatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20Yi%20ethnic%20girl%20student%20portrait%2C%20Sichuan%20rural%20area%2C%20warm%20smile%2C%20simple%20background&width=60&height=60&seq=dr004&orientation=squarish',
    donorAvatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20university%20student%20portrait%2C%20friendly%20smile%2C%20clean%20background&width=60&height=60&seq=dd004&orientation=squarish',
    thankNote: '有了英语词典，我再也不用担心查不到单词了！谢谢哥哥，我要努力学英语！',
  },
  {
    id: 'd5',
    donor: '爱心家长·赵女士',
    donorCity: '杭州',
    amount: 800,
    date: '2026-04-06',
    gifts: ['冬季棉服×5', '保暖手套×10', '围巾×5'],
    recipient: '西藏林芝·扎西',
    recipientGrade: '小学五年级',
    recipientRegion: '西藏自治区林芝市',
    status: '配送中',
    recipientAvatar: 'https://readdy.ai/api/search-image?query=young%20Tibetan%20boy%20student%20portrait%2C%20Tibet%20rural%20area%2C%20warm%20smile%2C%20simple%20background&width=60&height=60&seq=dr005&orientation=squarish',
    donorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20professional%20woman%20portrait%2C%20caring%20expression%2C%20clean%20background&width=60&height=60&seq=dd005&orientation=squarish',
    thankNote: '',
  },
  {
    id: 'd6',
    donor: '爱心老师·陈老师',
    donorCity: '成都',
    amount: 400,
    date: '2026-04-05',
    gifts: ['数学辅导书×8', '文具盒×8', '钢笔×8'],
    recipient: '湖南湘西·土家族学生',
    recipientGrade: '初中一年级',
    recipientRegion: '湖南省湘西土家族苗族自治州',
    status: '已送达',
    recipientAvatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20Tujia%20ethnic%20students%20portrait%2C%20Hunan%20rural%20area%2C%20happy%20smiles%2C%20simple%20background&width=60&height=60&seq=dr006&orientation=squarish',
    donorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20teacher%20portrait%2C%20professional%20smile%2C%20clean%20background&width=60&height=60&seq=dd006&orientation=squarish',
    thankNote: '有了新文具，上课更有动力了！老师说我们的数学成绩进步了很多，谢谢陈老师！',
  },
];

export const villageLifePosts = [
  {
    id: 'v1',
    author: '大山里的阿牛',
    region: '四川大凉山',
    grade: '初中二年级',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20rural%20boy%20student%20portrait%2C%20mountain%20village%20background%2C%20genuine%20smile%2C%20simple%20clothes&width=80&height=80&seq=v001&orientation=squarish',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20Chinese%20mountain%20village%20sunrise%20landscape%2C%20misty%20mountains%2C%20rural%20path%2C%20golden%20morning%20light%2C%20scenic%20countryside&width=600&height=400&seq=vi001&orientation=landscape',
    content: '每天早上5点起床，走40分钟山路去上学。虽然辛苦，但看到山顶的日出，感觉一切都值得。城市的同学们，你们也要珍惜每天上学的机会哦！',
    likes: 4521,
    comments: 678,
    time: '2天前',
    tags: ['农村生活', '励志', '山路上学'],
  },
  {
    id: 'v2',
    author: '苗家小妹',
    region: '贵州黔东南',
    grade: '高中一年级',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20Miao%20ethnic%20girl%20student%20portrait%2C%20traditional%20elements%2C%20warm%20smile%2C%20clean%20background&width=80&height=80&seq=v002&orientation=squarish',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20Miao%20ethnic%20village%20scenery%2C%20traditional%20wooden%20houses%2C%20green%20rice%20terraces%2C%20misty%20morning%2C%20beautiful%20rural%20landscape&width=600&height=400&seq=vi002&orientation=landscape',
    content: '我们苗寨的稻田今年丰收了！爸爸妈妈很开心。我在田边复习功课，感受着大自然的美好。希望城市的同学们有机会来我们这里看看，这里虽然穷，但风景真的很美！',
    likes: 3890,
    comments: 456,
    time: '3天前',
    tags: ['苗寨', '丰收', '农村美景'],
  },
  {
    id: 'v3',
    author: '小雨（贵州）',
    region: '贵州遵义',
    grade: '初中三年级',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20girl%20student%20portrait%2C%20rural%20background%2C%20hopeful%20eyes%2C%20simple%20clothes&width=80&height=80&seq=v003&orientation=squarish',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20rural%20village%20school%20classroom%2C%20simple%20wooden%20desks%2C%20children%20studying%2C%20warm%20sunlight%20through%20windows%2C%20heartwarming%20scene&width=600&height=400&seq=vi003&orientation=landscape',
    content: '这是我们的教室，虽然简陋，但每个同学都很认真。我们没有多媒体设备，但老师用粉笔把知识写在黑板上，我们用心记在脑子里。感谢城市的哥哥姐姐们给我们捐来的新课桌！',
    likes: 5234,
    comments: 789,
    time: '4天前',
    tags: ['农村学校', '感恩', '努力学习'],
  },
  {
    id: 'v4',
    author: '扎西（西藏）',
    region: '西藏林芝',
    grade: '小学五年级',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Tibetan%20boy%20student%20portrait%2C%20Tibet%20rural%20area%2C%20warm%20smile%2C%20simple%20background&width=80&height=80&seq=v004&orientation=squarish',
    image: 'https://readdy.ai/api/search-image?query=Tibet%20Linzhi%20landscape%2C%20snow%20mountains%2C%20pine%20forests%2C%20Tibetan%20village%2C%20clear%20blue%20sky%2C%20beautiful%20natural%20scenery&width=600&height=400&seq=vi004&orientation=landscape',
    content: '我们西藏的天空是最蓝的！今天用城市哥哥姐姐捐来的新书包去上学，感觉特别神气。我要好好学习，将来去北京上大学，看看外面的世界！',
    likes: 6789,
    comments: 1023,
    time: '5天前',
    tags: ['西藏', '蓝天', '梦想'],
  },
];

export const scoreRewards = [
  { action: '每日登录', score: 10, icon: 'ri-calendar-check-line', color: 'text-green-600' },
  { action: '发布动态', score: 20, icon: 'ri-quill-pen-line', color: 'text-blue-600' },
  { action: '帮助他人', score: 50, icon: 'ri-hand-heart-line', color: 'text-rose-600' },
  { action: '上传文档', score: 30, icon: 'ri-file-upload-line', color: 'text-amber-600' },
  { action: '连续登录7天', score: 100, icon: 'ri-fire-line', color: 'text-orange-600' },
  { action: '爱心捐款', score: 200, icon: 'ri-heart-fill', color: 'text-red-600' },
];

export const leaderboard = [
  { rank: 1, name: '陈大学姐', score: 4580, avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20female%20university%20student%20portrait%2C%20confident%20smile%2C%20clean%20background%2C%20academic%20look&width=60&height=60&seq=lb001&orientation=squarish', badge: '爱心达人' },
  { rank: 2, name: '王老师', score: 3920, avatar: 'https://readdy.ai/api/search-image?query=Chinese%20middle-aged%20male%20teacher%20portrait%2C%20professional%20look%2C%20glasses%2C%20warm%20smile%2C%20clean%20background&width=60&height=60&seq=lb002&orientation=squarish', badge: '优秀教师' },
  { rank: 3, name: '张英语老师', score: 3450, avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20English%20teacher%20portrait%2C%20professional%20smile%2C%20warm%20expression%2C%20clean%20background&width=60&height=60&seq=lb003&orientation=squarish', badge: '公益先锋' },
  { rank: 4, name: '小明（北京）', score: 2890, avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20boy%20student%20smiling%20portrait%2C%20school%20uniform%2C%20clean%20white%20background&width=60&height=60&seq=lb004&orientation=squarish', badge: '学习达人' },
  { rank: 5, name: '苗家小妹', score: 2340, avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20Miao%20ethnic%20girl%20student%20portrait%2C%20traditional%20elements%2C%20warm%20smile&width=60&height=60&seq=lb005&orientation=squarish', badge: '分享之星' },
];
